/**
 * CP-202: not-found page for /cruise/<id>.
 *
 * nginx answers an unknown or hidden sailing with a real 404 (the SPA shell
 * with X-Robots-Tag: noindex). The shell then boots, the Detail API call 404s,
 * and the app shows this page instead of "Failed to load cruise data".
 * Client-side navigations get the same page, and a noindex robots meta so a
 * crawler that renders JavaScript does not index it either.
 */

export const NOT_FOUND_COPY = {
  cruise: {
    title: "This sailing isn't available",
    message: 'It may have been removed or sold out, or the link may be mistyped. Browse current sailings to find another.',
  },
  page: {
    title: 'Page not found',
    message: "The page you're looking for doesn't exist or has moved.",
  },
};

export const BROWSE_PATH = '/cruises';

export function notFoundCopy(variant) {
  return NOT_FOUND_COPY[variant] || NOT_FOUND_COPY.page;
}

/** True only for an HTTP 404 from the API; network errors and 5xx stay "Try again". */
export function isNotFoundError(err) {
  return Boolean(err && err.response && err.response.status === 404);
}

const ROBOTS_ATTR = 'data-cs-not-found';

/** Adds <meta name="robots" content="noindex"> and returns a function that removes it. */
export function applyNoindex(doc) {
  if (!doc || !doc.head || typeof doc.createElement !== 'function') return () => {};
  const meta = doc.createElement('meta');
  meta.setAttribute('name', 'robots');
  meta.setAttribute('content', 'noindex');
  meta.setAttribute(ROBOTS_ATTR, '1');
  doc.head.appendChild(meta);
  return () => {
    if (meta.parentNode) meta.parentNode.removeChild(meta);
  };
}
